import Menu_kghead from './menu';
import Menu_medical from './menu_medical';
import Menu_admin from './menu_admin';
import Menu_moderator from './menu_moderator';


export const config = {
        cabinetMenu:{
            'kindergartenHead:admin': Menu_admin,
            'kindergartenHead:specialist': Menu_admin,
            'kindergartenHead:superadmin': Menu_admin,
            'kindergartenHead:moderator': Menu_moderator,
            'kindergartenHead': Menu_kghead,
            'nurse': Menu_medical
        }
}